import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const networkErrorInterceptor: HttpInterceptorFn = (req, next) => {

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Error de red (sin internet o servidor caído)
      if (error.status === 0) {
        console.error('❌ Error de red: Sin conexión a internet o servidor no disponible');

        // Opcionalmente redirigir a una página de error
        // router.navigate(['/sin-conexion']);
      }

      // Error del servidor
      if (error.status >= 500) {
        console.error('❌ Error del servidor:', error.status);
      }

      // Error de cliente (404, 403, etc)
      if (error.status >= 400 && error.status < 500) {
        console.error('❌ Error del cliente:', error.status, error.message);
      }

      return throwError(() => error);
    })
  );
};
